import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { Button } from '../ui';
import ResetPasswordModal from './ResetPasswordModal';
import { api } from '../../services';
import { useTranslation } from 'react-i18next';
import { translateAuthApiMessage } from '../../utils/translateAuthApiMessage';

function ForgotPasswordModal({ show, onClose }) {
    const {t} = useTranslation("translation");
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    const [resetSent, setResetSent] = useState(false);
    const [showResetPassword, setShowResetPassword] = useState(false);

    const handleForgotPassword = async () => {
        try {
            await api.post('/forgot-password', { email });
            setErrorMessage(null);
            setResetSent(true);
        } catch (error) {
            setResetSent(false);
            setErrorMessage(error.response?.data?.message ?? "");
        }
    };

    const handleResetClick = () => {
        setShowResetPassword(true);
    };

    return (
        <>
            <Modal show={show} onHide={onClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Forgot Password")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {resetSent ? (
                        <div className="text-center">
                            <p className="text-success">
                                {t("A reset link has been sent to your email address.")}
                            </p>
                            {/* <Button variant="primary" onClick={handleResetClick} className="w-100">
                                Reset Password
                            </Button> */}
                        </div>
                    ) : (
                        <Form>
                            <Form.Group controlId="email" className="mb-3">
                                <Form.Control
                                    type="email"
                                    placeholder={t("Enter your email")}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Form.Group>
                            {errorMessage != null && (
                                <p className="text-danger mt-3">
                                    {translateAuthApiMessage(errorMessage, t) ||
                                        t("An error occurred")}
                                </p>
                            )}
                            <Button variant="primary" onClick={handleForgotPassword} className="w-100">
                                {t("Send Reset Link")}
                            </Button>
                        </Form>
                    )}
                </Modal.Body>
            </Modal>

            <ResetPasswordModal
                show={showResetPassword}
                onClose={() => setShowResetPassword(false)}
            />
        </>
    );
}

export default ForgotPasswordModal;
